"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUUIDv4 = exports.isStringOfLength = exports.isString = void 0;
var _constants = require("../../config/constants");
var _isDefined = require("../misc-checks/isDefined");
var _isOfLength = require("../misc-checks/isOfLength");
var isString = exports.isString = function isString(targetString) {
  return (0, _isDefined.isDefined)(targetString) && typeof targetString === "string";
};
var isStringOfLength = exports.isStringOfLength = function isStringOfLength(targetString) {
  return isString(targetString) && (0, _isOfLength.isOfLength)(targetString.trim());
};
var isUUIDv4 = exports.isUUIDv4 = function isUUIDv4(targetString) {
  return isStringOfLength(targetString) && new RegExp(_constants.EXP_UUIDV4).test(targetString);
};